import { useQuery, useMutation } from "react-query";
import { SubscriptionsService } from "./subscriptions.service";
import toast from "react-hot-toast";

// GET List
const useGetList = (page: number, option?: Object) => {
  return useQuery(
    ["listSubscriptions", page, option],
    async () => {
      const { data } = await SubscriptionsService.getListSubscriptions({
        page,
        ...option,
      });
      return data;
    },
    { keepPreviousData: true },
  );
};

const usePayment = (cb?: (data: any) => void) => {
  return useMutation(
    async (idItem: string) => {
      const data = await SubscriptionsService.createPayment(idItem);
      return data;
    },
    {
      onSuccess: (data) => {
        cb?.(data);
        if (data.ok) {
          toast.success("Create successfully!");
        } else {
          toast.error(data?.msg);
        }
      },
      onError(error) {
        alert(error);
      },
    },
  );
};

// DELETE Detail
const useActive = (cb?: (data: any) => void) => {
  return useMutation(
    async (idItem: string) => {
      const data = await SubscriptionsService.active(idItem);
      return data;
    },
    {
      onSuccess: (data) => {
        cb?.(data);
        if (data.ok) {
          toast.success("Active successfully!");
        } else {
          toast.error(data?.msg);
        }
      },
      onError(error) {
        alert(error);
      },
    },
  );
};

const useDeActive = (cb?: (data: any) => void) => {
  return useMutation(
    async (idItem: string) => {
      const data = await SubscriptionsService.deActive(idItem);
      return data;
    },
    {
      onSuccess: (data) => {
        cb?.(data);
        if (data.ok) {
          toast.success("Action successfully!");
        } else {
          toast.error(data?.msg);
        }
      },
      onError(error) {
        alert(error);
      },
    },
  );
};

// DELETE
const useDelete = (cb?: (data: any) => void) => {
  return useMutation(
    async (idSubscription: string) => {
      const data =
        await SubscriptionsService.deleteSubscription(idSubscription);
      return data;
    },
    {
      onSuccess: (data) => {
        cb?.(data);
        if (data.ok) {
          toast.success("Delete success!");
        } else {
          toast.error(data?.msg);
        }
      },
      onError(error) {
        alert(error);
      },
    },
  );
};

export { useGetList, useActive, usePayment, useDeActive, useDelete };
